import { lighten } from '@mui/material';

export const makeIllustrationColor = (baseColor: string): string => lighten(baseColor, 0.9);
